import axios from 'axios';
import {Loading, Message} from 'element-ui';
import router from '../router';

// 超时时间
axios.defaults.timeout = 3000000;


axios.interceptors.request.use(config => {
    var token = sessionStorage.getItem('token');
    if (token) {
        config.headers.token = token;
    } else {
        if (config.url === "/api/user/login" || config.url === "/api/check/player/login" || config.url === "/api/match/get") {

        } else {
            Message.error({
                message: '登录超时！请重新登录'
            });
            gotoLogin('/login');
        }
    }
    return config;
}, error => {
    Message.error({
        message: '加载超时'
    });
    return Promise.reject(error);
});
// http响应拦截器
axios.interceptors.response.use(data => { // 响应成功关闭loading
    return data;
}, error => {
    if (error.response.status === 504) {
        Message.error({
            message: '请求超时,请稍后再试！'
        });
    }
    if (error.response.status == 403 || error.response.status == 401) {
        localStorage.clear();
        Message.error({
            message: '登录超时,请重新登录！'
        });
        gotoLogin('/login');
    }
    return Promise.reject(error);
});

function gotoLogin(path) {
    router.replace({path: path});
}

export default axios;



// WEBPACK FOOTER //
// ./src/common/axios.js